import SmartMap from "./SmartMap";
import SmartFile from "./SmartFile";

const smart = {
  chooseLocation: SmartMap.chooseLocation,
  openLocation: SmartMap.openLocation,
  previewImage: SmartFile.previewImage,
  openFile: SmartFile.openFile,
  downloadFile: SmartFile.downloadFile,
  openMedia: SmartFile.openMedia,
};

export interface SmartOption {
  mapKey: string | string[];
  filePreviewUrl?: String;
}

const install = function (Vue: any, opts = {} as SmartOption) {
  Vue.use(SmartMap, opts);
  Vue.use(SmartFile, opts);
  Vue.prototype.$smart = smart;
};

/* istanbul ignore if */
// if (typeof window !== "undefined" && window.Vue) {
//   install(window.Vue,window.smartmap);
// }

export default {
  version: "1.0.1",
  install,
  ...smart,
};
